<template>
  <div class="t-lk-container">
    <div v-animation:bottom.delay class="t-lk-title-link t-lk-container-mobile t-lk-materials__title">
      <h1 class="t-lk-title t-lk-title-link__title">{{ $root.staticText.lk.materialsWLTitle }}</h1>
    </div>

    <div v-animation:bottom.delay class="t-lk-materials__filter">
      <filter-cmp
        v-if="filter"
        :filter="filter"
        :name-btn="$root.staticText.lk.materialsFilterBtn"
        :obj-undefined="{ currentPage: undefined }"
        :white="true"
        :is-date="true"
        :is-date-left="false"
      >
      </filter-cmp>
    </div>

    <div class="t-lk-materials__container js-materials-white-label">
      <router-link
        v-animation:bottom.delay
        v-for="(item, idx) in materials"
        :key="`materials-item_${item.id}_${idx}`"
        :to="item.link"
        class="t-lk-materials-wl__item"
      >
        <div class="t-lk-materials-wl__img">
          <img v-if="item.img" :src="item.img" :alt="item.name" />
        </div>
        <div class="t-lk-materials-wl__wrap">
          <div class="t-lk-materials-wl__name">{{ item.name }}</div>
          <div class="t-lk-materials-wl__date">{{ item.date }}</div>
        </div>
      </router-link>
    </div>
    <pagination-cmp v-animation:bottom.delay v-if="pagination" :pagination="pagination" :name-current-page="'currentPage'" class="_lk">
    </pagination-cmp>
  </div>
</template>

<script>
import Vue from "vue"
import filter from "@components/lk/lk-filter/lk-filter"
import pagination from "@ui/pagination/pagination"
import onScrollAnimate from "@assets/js/scrollAnimate"

export default {
  name: "materials-white-label",
  data() {
    return {
      filter: null,
      materials: [],
      pagination: null,
    }
  },
  components: {
    "filter-cmp": filter,
    "pagination-cmp": pagination,
  },
  methods: {
    setData(data) {
      this.filter = data.filter
      this.materials = data.materials
      this.pagination = data.pagination
    },
  },
  beforeRouteUpdate(to, from, next) {
    let url = process.env.NODE_ENV !== "production" ? "lk/materialsWhiteLabel.json" : "lk/materials-white-label"

    this.$root.setDataAnimateFalse(".js-materials-white-label ")

    Vue.http.get(url, { params: to.query }).then(
      data => {
        this.setData(data.data)
        next()
        setTimeout(() => {
          onScrollAnimate()
        }, 500)
      },
      data => {
        if (data.status === 403) {
          next({ name: "E403" })
        } else {
          next({ name: "E404" })
        }
      }
    )
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== "production" ? "lk/materialsWhiteLabel.json" : "lk/materials-white-label"
    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: "E403" })
        } else {
          next({ name: "E404" })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/materials/materials-white-label/index.vue